import React from 'react';

// Stack of cards — primary brand mark (yellow / green / blue tropical variant)
// Final colors: #ffc244 (bottom), #2bbf85 (middle), #3a7bd5 (top)
export function BrandMark({ size = 32, colors }) {
  const trio = Array.isArray(colors) && colors.length >= 3 ? colors : ['#ffc244', '#2bbf85', '#3a7bd5'];
  const [c1, c2, c3] = trio;
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="none">
      <rect x="2.4" y="10.4" width="20.8" height="14.4" rx="2.8" fill={c1} />
      <rect x="5.6" y="8" width="20.8" height="14.4" rx="2.8" fill={c2} />
      <rect x="8.8" y="5.6" width="20.8" height="14.4" rx="2.8" fill={c3} />
      <path d="M12.8 10.4h11.2M12.8 12.8h7.2" stroke="#fff" strokeWidth="0.96" strokeLinecap="round" />
    </svg>
  );
}

// Larger version for splash / login screen
export function BrandMarkLarge({ size = 80 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 80 80" fill="none">
      <rect x="6" y="26" width="52" height="36" rx="7" fill="#ffc244" />
      <rect x="14" y="20" width="52" height="36" rx="7" fill="#2bbf85" />
      <rect x="22" y="14" width="52" height="36" rx="7" fill="#3a7bd5" />
      <path d="M32 26h28M32 32h18" stroke="#fff" strokeWidth="2.4" strokeLinecap="round" />
    </svg>
  );
}

export default BrandMark;
